import React from 'react';
import SceErrorBox from '../../../../../../../../Common/ErrorBox/sceErrorBox';
import SceText from '../../../../../../../common/centralizedTextBox';
import classes from './cppTextDropDown.scss';
import { getLocalizedStrings } from "../../../../../../../centralizedLocalizedString";


class TextDropDown extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          emailValue: "",
          optionsOpen:false,
          emails:[],
          stylingClass: 'no-icon',
          displayDefaultText: true,
          isError: false,
          isValid: false,
          isReset: false,
          validationType:null,
          maxInputLength:null,
          errorMsgToShow:null,
          cppInput: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false,isValid:false },
          cppInputError: true,inputVal:"",isAddBtnDisabled:null, show:"",enteredValue:'',
          inputValid:(this.props.inputButtonText==="Save" && this.props.contactType==="email") ? true : false,
        };
        this.strings = getLocalizedStrings('CppAlerts');
        this.selectedValue = 'invalid',
        this.defaultText = 'Choose an Option';
        this.showErrorMessage = false;
        this.forceValidate = false;
        this.wasDropdownFocussed=false;
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
      }

      componentWillMount(){
        if(!_.isEmpty(this.props.contactType)&&(this.props.contactType==='email')){
          this.setState({validationType:'cenPrefEmail',maxInputLength:45,errorMsgToShow:'Please enter a valid email id.'});
        }else{
          this.setState({validationType:'cenPrefPhone',maxInputLength:13,errorMsgToShow:'Please enter a valid phone number.'});
        }
      }

      componentDidMount(){
        document.addEventListener('mousedown', this.handleClickOutside);
        const updatedState = { ...this.state };
        if (this.props.selectBoxData.length) {
          let filtered = this.props.selectBoxData;
          filtered.map((emailSearch) => {
            updatedState.emails.push(emailSearch.value);
          });
          this.setState(updatedState);
        }
      }
      componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
      setWrapperRef(node) {
        this.wrapperRef = node;
      }
      handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
          this.props.triggerOnClick();
        }
      }

      onKeyPressHandler=(e,name,value)=>{
        const updatedState = { ...this.state };
        updatedState.emailValue = e.target.value;
        updatedState.optionsOpen=true;
        this.setState(updatedState);
        if (e.key === 'Enter' || e.key === ' ') {
          this.onSelectOption(e,this.state.emailValue,this.state.emailValue,encNum);
        }
      }
      
      inputChangeHandler = (e) => {
        if(!e.isError){
          let updatedState = { ...this.state };
          updatedState.emailValue = e.value;
          updatedState.inputVal=e.value;
          updatedState.optionsOpen=true;
          updatedState.cppInputError=false;
          updatedState.cppInput.isError=false;
          this.setState(updatedState);
        }else{
          let updatedState = { ...this.state };
          updatedState.inputVal=e.value;
          updatedState.cppInputError=true;
          updatedState.cppInput.isError=true;
          updatedState.cppInput.isValid=false;
          this.setState(updatedState);
        }
        }
        onChangeHandler = (inputValue) => {
          this.setState({enteredValue:inputValue,show:"addShow"},()=>{
            this.validateInput(this.state.enteredValue);
          });
         }
         validateInput(inputValue){
           let updatedState={...this.state};
           if(this.props.contactType==="email"){
            let isEmailValid=app.appUtil.isValidEmail(inputValue);
            isEmailValid ? updatedState.inputValid=true : updatedState.inputValid=false;
           }
           else{
             let regex=new RegExp(/^([0-9]{3})[-]([0-9]{3})[-]([0-9]{4})$/);
             let isPhoneValid=regex.test(inputValue);
             isPhoneValid ? updatedState.inputValid=true : updatedState.inputValid=false;
             }
           this.setState(updatedState);
          }   
      
      onAddNewContactHandler = (e,name,value,encNum)=>{
        if((!this.state.cppInputError)&&(!_.isEmpty(value))){
          if(this.props.contactType==="email"){
            if(!this.ifEmailExists(value)){
              this.props.onAddEmailConfirmDialogClick(e,name,value,encNum);
            }
          else this.onSelectOption(e,name,value,encNum);
          }
          else{
            let enteredValue = value.split("-").join("");
            app.centralizedService.getEncryptedPhoneNumber(enteredValue).then(response=>{
             if(!this.ifPhoneExists(response.phoneNumber)){
                this.props.onAddPhoneConfirmDialogClick(e,name,enteredValue,response.phoneNumber);
                }
             else this.onSelectOption(e,name,enteredValue,response.phoneNumber);             
             },error=>{
              this.setState({isError: true});
             });
          }
        }else{
          let updatedState = { ...this.state };
          updatedState.cppInput.isError=true;
          updatedState.cppInput.isValid=false;
          this.setState(updatedState);
        }
        
      }
        
        

    onSelectOption = (e,name,value,encNum) => {
        const updatedState = { ...this.state };
        updatedState.optionsOpen=false;
        switch(this.props.contactType){
          case "email":{
            if(_.contains(this.props.addContactValueArr.email,value)){
              updatedState.cppInput.isError=true;
              updatedState.errorMsgToShow = this.strings.emailSameValueErrorMsg;
            }else{
              updatedState.cppInput.isError=false;
            }
            break;
          }
          case "text":{
            if(_.contains(this.props.addContactEncValueArr.text,encNum)){
              updatedState.cppInput.isError=true;
              updatedState.errorMsgToShow = this.strings.voiceSameValueErrorMsg;
            }else{
              updatedState.cppInput.isError=false;
            }
            break;
          }
          default:{
            if(_.contains(this.props.addContactEncValueArr.voice,encNum)){
              updatedState.cppInput.isError=true;
              updatedState.errorMsgToShow = this.strings.voiceSameValueErrorMsg;
            }else{
              updatedState.cppInput.isError=false;
            }
          }
        }
        if(!updatedState.cppInput.isError){
          let data = {
            value: value,
            name: name,
            encNum: encNum || "",
            isValid: (value.toUpperCase() !== 'INVALID') ? true : false,
            isError: (value.toUpperCase() !== 'INVALID') ? false : true,
            modifyChild: '',
          };
          this.selectedValue = data.value;
          data.isValidated = data.isValid && !data.isError ? true : false;  
          data.isDropDownSelectError = data.value==='' ? true: false;
          this.props.handleClick(data);
          this.props.onDoneEnabledButton(false);
        }
        this.setState(updatedState);
      }
      ifEmailExists(contactType) {
        for(let i=0; i<this.props.selectBoxData.length; i++) {
            if(contactType.toLowerCase() === this.props.selectBoxData[i].value.toLowerCase())
                return true;
          }
        return false;
      }
      ifPhoneExists(contactType) {
        for(let i=0; i<this.props.selectBoxData.length; i++) {
            if(contactType === this.props.selectBoxData[i].encryptedPhoneNumber)
                return true;
          }
        return false;
      }
    render() {
    return (
      <div ref={this.setWrapperRef} >
        <div className={classes.dropdown} >
          <div className={classes.dropdownBtn}>
            <div>
              <div className={classes.box}>
                <span className={classes.sceTextBox}>
                <SceText /*className={classes.inputDisplay}*/
                    id='cppInput'
                    type={this.state.validationType}
                    maxLength={this.state.maxInputLength}
                    validator={app.appUtil.validator}
                    isError={this.state.cppInput.isError}
                    errorMsg={this.state.errorMsgToShow}
                    onTextUpdatedHandler={this.inputChangeHandler.bind(this)} 
                    onFocusHandler={this.inputChangeHandler.bind(this)}
                    onKeyPressHandler={this.inputChangeHandler.bind(this)}
                    onBlurHandler={this.props.triggerOnClick}                    
                    placeholder={this.props.inputButtonText!=="Save" || this.props.contactType!=="email" ? this.props.placeholder :""}
                    defaultValue={this.props.inputButtonText==="Save" && this.props.contactType==="email" ? this.props.placeholder : ""}
                    onChangeHandler={this.onChangeHandler.bind(this)}
                    // added for removing autocomplte in edge browser.
                    autoComplete="sceCppAnnDropdownInput"
                    />
                     {(this.state.optionsOpen) ?
            <div className={classes.dropdownContent}>
              {this.props.selectBoxData.map((email)=>{
                return<div className={classes.dropdownItem} > 
                  <a href='javascript:;' value={email.value} name={email.name} id={this.props.id + email.value} onClick={(event,name,value,encNum) => this.onSelectOption(event,email.name,email.value,email.encryptedPhoneNumber)} >
                    {email.value.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c)} 
                  </a>
                </div>;
            })}
            </div>
            : null
          }
                </span>
                <span className={classes.addCancelButtonAlign}>
                {(this.state.show==="addShow" || this.props.inputButtonText==="Save") ? 
                <div>
                  <span className={classes.addButtonAlign}>
                    <button
                      className={this.state.inputValid ? classes.AddButton : classes.AddDisabledButton}
                      onClick={(event, name, value, encNum) => this.onAddNewContactHandler(event, this.state.emailValue, this.state.emailValue)}
                    >
                      {this.props.inputButtonText}
                    </button>
                  </span>
                  <span className={classes.EditButtonAlign}>
                    <button className={classes.CancelButton}
                      onClick={this.props.triggerOnClick}>Cancel</button>
                  </span>
                  </div>:null}
                </span>
              </div>
            </div>
          </div> 
        </div>
        <SceErrorBox errorMessage={this.props.isError ? this.props.errorMessage : this.props.selectErrorMessage} isError={this.showErrorMessage} />
      </div>
    );
  }
    
    

}
export default TextDropDown;
